module.exports = __webpack_public_path__ + "img/total-budget.5462a11f.svg";